<template functional>
  <i
    v-bind="(() => ({
        ...data.attrs,
        /* ルート要素に利用側の scope ID を設定し、利用側の指定する scoped なクラスのスタイル（position などのレイアウト調整）を適用できるようにする */
        /* functional なコンポーネントの場合だけ必要になる特殊処理. :class=data.staticClass も必要 */
        [parent.$options._scopeId]: '',
    }))()"
    class="tkCrossMark"
    :class="data.staticClass"
    :style="{
      '--width': `${props.width}px`,
      '--length': `${props.length}px`,
    }"
  />
</template>

<script>
export default {
  name: 'TkCrossMark',
  props: {
    width: {
      type: Number,
      default: 3,
    },
    length: {
      type: Number,
      default: 8,
    },
  },
}
</script>

<style scoped lang="scss">
.tkCrossMark {
  &::before {
    position: absolute;
    left: var(--length);
    transform: rotate(225deg);
    width: var(--length);
    height: var(--length);
    margin: auto;
    border-right: var(--width) solid;
    border-top: var(--width) solid;
    vertical-align: middle;
    content: "";
  }
  &::after {
    position: absolute;
    left: 0;
    transform: rotate(45deg);
    width: var(--length);
    height: var(--length);
    margin: auto;
    border-right: var(--width) solid;
    border-top: var(--width) solid;
    vertical-align: middle;
    content: "";
  }
}
</style>
